class FreeShippingBar {
  constructor(root) {
    this.root = root;
    this.threshold = parseInt(root.dataset.threshold, 10) || 0;
  }

  formatMoney(paise) {
    if (typeof paise !== 'number' || isNaN(paise)) return '';
    const format = (window.freeShippingConfig && window.freeShippingConfig.moneyFormat) || '\u20b9{{amount}}';
    const value = paise / 100;
    const amount =
      value % 1 === 0
        ? value.toLocaleString('en-IN')
        : value.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return format.replace('{{amount}}', amount);
  }

  update(total) {
    if (!this.threshold || typeof total === 'undefined') return;

    const remaining = this.threshold - total;
    const unlocked = remaining <= 0;
    const progress = Math.max(0, Math.min(100, Math.round((total / this.threshold) * 100)));
    const money = (paise) => this.formatMoney(Math.max(0, paise));

    const wasUnlocked = this.root.classList.contains('free-shipping-progress--unlocked');
    this.root.classList.toggle('free-shipping-progress--unlocked', unlocked);

    if (unlocked && !wasUnlocked) {
      this.root.classList.add('free-shipping-progress--pop');
      setTimeout(() => this.root.classList.remove('free-shipping-progress--pop'), 500);
    }

    this.root.style.setProperty('--fs-progress', `${progress}%`);

    const progressbar = this.root.querySelector('[role="progressbar"]');
    if (progressbar) progressbar.setAttribute('aria-valuenow', progress);

    const current = this.root.querySelector('[data-current]');
    if (current) current.textContent = money(total);

    const message = this.root.querySelector('[data-message]');
    if (message) {
      message.innerHTML = unlocked
        ? '🎉 Congratulations! You unlocked FREE Shipping.'
        : `🎉 You're only <strong>${money(remaining)}</strong> away from FREE Shipping!`;
    }

    const note = this.root.querySelector('[data-note]');
    if (note) {
      note.innerHTML = unlocked
        ? '🚚 FREE Shipping Applied'
        : `Spend <strong>${money(remaining)}</strong> more to unlock FREE Shipping.`;
    }
  }
}

function updateAllFreeShippingBars(total) {
  document.querySelectorAll('.free-shipping-progress').forEach((root) => {
    new FreeShippingBar(root).update(total);
  });
}

(function () {
  if (window.freeShippingProgressInitialized) return;
  window.freeShippingProgressInitialized = true;

  function init() {
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.cartData && typeof event.cartData.total_price !== 'undefined') {
          updateAllFreeShippingBars(event.cartData.total_price);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
